/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Responsive typography settings with font and sizes for different breakpoints.
 * @export
 * @interface ChallengeResponsiveTypography
 */
export interface ChallengeResponsiveTypography {
    /**
     * 
     * @type {string}
     * @memberof ChallengeResponsiveTypography
     */
    font?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeResponsiveTypography
     */
    desktopSize?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeResponsiveTypography
     */
    tabletSize?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeResponsiveTypography
     */
    mobileSize?: string;
}

/**
 * Check if a given object implements the ChallengeResponsiveTypography interface.
 */
export function instanceOfChallengeResponsiveTypography(value: object): value is ChallengeResponsiveTypography {
    return true;
}

export function ChallengeResponsiveTypographyFromJSON(json: any): ChallengeResponsiveTypography {
    return ChallengeResponsiveTypographyFromJSONTyped(json, false);
}

export function ChallengeResponsiveTypographyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeResponsiveTypography {
    if (json == null) {
        return json;
    }
    return {
        
        'font': json['font'] == null ? undefined : json['font'],
        'desktopSize': json['desktopSize'] == null ? undefined : json['desktopSize'],
        'tabletSize': json['tabletSize'] == null ? undefined : json['tabletSize'],
        'mobileSize': json['mobileSize'] == null ? undefined : json['mobileSize'],
    };
}

export function ChallengeResponsiveTypographyToJSON(json: any): ChallengeResponsiveTypography {
    return ChallengeResponsiveTypographyToJSONTyped(json, false);
}

export function ChallengeResponsiveTypographyToJSONTyped(value?: ChallengeResponsiveTypography | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'font': value['font'],
        'desktopSize': value['desktopSize'],
        'tabletSize': value['tabletSize'],
        'mobileSize': value['mobileSize'],
    };
}

